<template>
    <div v-if="isVisible" class="popup-overlay">

        <div class="popup-frame">
            <v-btn icon small class="close-btn" @click="close">
                <v-icon color="#0b1533">mdi-close</v-icon>
            </v-btn>

            <div class="popup-card">

                <div class="col-left">
                    <div class="logos-wrapper">
                        <img src="@/assets/images/welcome-banner-logos.png" alt="Canal do Veículo, Canal do Anúncio e Canal do Mídia">
                    </div>

                    <h2 class="banner-title">
                        Atualize seu inventário de forma <span class="highlight">inteligente.</span>
                    </h2>

                    <div class="upload-block">
                        <img class="upload-icon" src="@/assets/images/welcome-banner-upload.png" alt="Ícone de upload">
                        <p class="upload-text">
                            <span class="highlight">Apenas faça upload</span> dos seus materiais e deixe nossa IA trabalhar.
                        </p>
                    </div>

                    <hr class="divider">

                    <p class="body-text">
                        Informações completas e de qualidade aumentam suas chances de vender mais!
                    </p>

                    <p class="body-text">
                        Mídia kit, tabela de preços, cobertura, audiência e especificações
                        técnicas facilitam a decisão de compra e evitam trocas
                        desnecessárias de e-mails.
                    </p>

                    <p class="cta-text">
                        <span>🚀</span> Aproveite e já suba tudo de uma vez!
                    </p>
                </div>

                <div class="col-right">
                    <div class="mockup-wrapper">
                        <img src="@/assets/images/welcome-banner-mockup.png" alt="Envio de materiais do veículo">
                    </div>

                    <v-btn large rounded dark color="#0f9d58" class="send-btn"
                        to="/app/inventory/formats?materials=1" @click="close">
                        Enviar materiais
                    </v-btn>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'WelcomeBanner',
    data() {
        return {
            isVisible: true
        }
    },
    methods: {
        close() {
            this.isVisible = false;
            this.$emit('close');
        }
    }
}
</script>


<style scoped>
        /* Overlay do pop-up */
        .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.55);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999;
        }

        .popup-frame {
            width: 900px;
            max-width: 95vw;
            border-radius: 28px;
            box-shadow: 0 25px 60px rgba(0, 0, 0, 0.25);
            position: relative;
        }

        .close-btn {
            position: absolute !important;
            top: -16px;
            right: -16px;
            z-index: 1000;
            background-color: #ffffff !important;
            box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
        }

        .close-btn:hover {
            background-color: #eef1f5 !important;
        }

        .popup-card {
            width: 100%;
            min-height: 600px;
            background: #ffffff;
            border-radius: 28px;
            overflow: hidden;
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: stretch;
        }

        .col-left {
            background: #0b1533;
            padding: 48px 52px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #c9cedb;
        }

        .logos-wrapper {
            width: 100%;
            height: 68px;
            margin-bottom: 26px;
        }

        .logos-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .banner-title {
            font-size: 30px;
            font-weight: 700;
            line-height: 1.2;
            color: #ffffff;
            margin: 0 0 22px 0;
            padding-left: 18px;
            border-left: 4px solid #0f9d58;
        }

        .highlight {
            color: #0f9d58;
        }

        .upload-block {
            display: flex;
            align-items: center;
            gap: 18px;
            margin-bottom: 22px;
        }

        .upload-icon {
            width: 84px;
            height: 84px;
            flex-shrink: 0;
            object-fit: contain;
        }

        .upload-text {
            font-size: 16px;
            line-height: 1.4;
            color: #ffffff;
            margin: 0;
        }

        .upload-text .highlight {
            font-weight: 600;
        }

        .divider {
            border: none;
            border-top: 1px solid rgba(255, 255, 255, 0.12);
            margin: 16px 0 20px 0;
        }

        .body-text {
            font-size: 14.5px;
            line-height: 1.5;
            color: #c9cedb;
            margin: 0 0 14px 0;
        }

        .cta-text {
            font-size: 14.5px;
            line-height: 1.5;
            color: #c9cedb;
            margin: 0;
            display: flex;
            align-items: flex-start;
            gap: 9px;
        }

        /* Coluna direita (clara) */
        .col-right {
            background: #eef1f5;
            padding: 48px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 28px;
        }

        .mockup-wrapper {
            width: 100%;
            height: 400px;
        }

        .mockup-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 18px;
        }

        .send-btn {
            color: #ffffff;
            font-weight: 700;
            letter-spacing: 0.5px;
            height: 48px !important;
            padding: 0 48px !important;
            box-shadow: 0 6px 16px rgba(15, 157, 88, 0.35);
        }

        /* Responsividade */
        @media (max-width: 900px) {
            .popup-frame {
                width: 95vw;
                border-radius: 20px;
            }

            .popup-card {
                grid-template-columns: 1fr;
                border-radius: 20px;
                min-height: auto;
                max-height: 90vh;
                overflow-y: auto;
            }

            .col-left {
                padding: 22px 20px;
            }

            .col-right {
                padding: 20px;
            }

            .banner-title {
                font-size: 20px;
            }

            .mockup-wrapper {
                height: 220px;
            }

            .logos-wrapper {
                height: 42px;
            }
        }
    </style>
